import React from 'react';

const RefundPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 text-[#23272f] dark:text-gray-200 transition-colors">
      <div className="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl sm:text-5xl font-extrabold mb-4 leading-tight text-gray-900 dark:text-white">Refund Policy</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8"><strong>Last Updated: {new Date().toLocaleDateString('en-US')}</strong></p>
        
        <div className="space-y-6 text-base leading-relaxed text-gray-700 dark:text-gray-300">
          <p>
            At <strong>AtlasSlicer</strong>, customer satisfaction is our highest priority. We want you to be completely delighted with our 2D sprite sheet slicing and texture atlas software. Because AtlasSlicer is sold as a <strong>one-time lifetime license</strong>, we offer a straightforward, risk-free refund policy.
          </p>

          <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-900 dark:text-white">1. 14-Day Money-Back Guarantee</h2>
          <p>
            We provide a <strong>14-day full money-back guarantee</strong> on all direct lifetime purchases of AtlasSlicer.
          </p>
          <p>
            If you are unsatisfied with AtlasSlicer for any reason, or encounter compatibility issues that prevent you from using the tool in your game engine workflow, you may request a 100% full refund within <strong>14 calendar days</strong> from the timestamp of your purchase.
          </p>

          <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-900 dark:text-white">2. Eligibility for Refund</h2>
          <p>To qualify for a refund, you must meet the following criteria:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Your refund request is submitted within 14 days of your initial purchase date.</li>
            <li>You purchased the license through our official checkout system (powered by Paddle).</li>
            <li>You agree to cease using and deactivate your license key upon receipt of the refund.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-900 dark:text-white">3. How to Request a Refund</h2>
          <p>
            Requesting a refund is simple and hassle-free. Simply send an email to our official customer support address:
          </p>
          <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-xl border border-gray-200 dark:border-gray-700 text-center font-mono my-4">
            <a href="mailto:support@atlasslicer.com" className="text-orange-500 font-bold hover:underline">
              support@atlasslicer.com
            </a>
          </div>
          <p>Please include the following information in your request so we can process it promptly:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Your purchase email address.</li>
            <li>Your Paddle Order ID or Transaction ID (found in your receipt email).</li>
            <li>A brief explanation of why you are requesting a refund (optional, but greatly appreciated to help us improve future versions of AtlasSlicer).</li>
          </ul>

          <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-900 dark:text-white">4. Refund Processing Time</h2>
          <p>
            Once your refund request is received, our support team will inspect and approve it within <strong>1-2 business days</strong>.
          </p>
          <p>
            The refund will be issued directly back to your original payment method (Credit Card, PayPal, Apple Pay, etc.) via Paddle. Depending on your financial institution or bank, the funds typically appear on your statement within <strong>3 to 7 business days</strong>.
          </p>

          <h2 className="text-2xl font-bold mt-10 mb-4 text-gray-900 dark:text-white">5. Contact Support</h2>
          <p>
            If you have any questions or concerns regarding our Refund Policy or need technical assistance prior to requesting a refund, please contact us anytime:
            <br />
            <strong>Support Email:</strong> <a href="mailto:support@atlasslicer.com" className="text-orange-500 hover:underline">support@atlasslicer.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;